import { __exports as emotionUseInsertionEffectWithFallbacks_cjs_prod } from '../../../../_virtual/emotion-use-insertion-effect-with-fallbacks.cjs.prod.js';
import React__default from 'react';

var hasRequiredEmotionUseInsertionEffectWithFallbacks_cjs_prod;

function requireEmotionUseInsertionEffectWithFallbacks_cjs_prod () {
	if (hasRequiredEmotionUseInsertionEffectWithFallbacks_cjs_prod) return emotionUseInsertionEffectWithFallbacks_cjs_prod;
	hasRequiredEmotionUseInsertionEffectWithFallbacks_cjs_prod = 1;

	Object.defineProperty(emotionUseInsertionEffectWithFallbacks_cjs_prod, '__esModule', { value: true });

	var React = React__default;

	function _interopNamespace(e) {
	  if (e && e.__esModule) return e;
	  var n = Object.create(null);
	  if (e) {
	    Object.keys(e).forEach(function (k) {
	      if (k !== 'default') {
	        var d = Object.getOwnPropertyDescriptor(e, k);
	        Object.defineProperty(n, k, d.get ? d : {
	          enumerable: true,
	          get: function () {
	            return e[k];
	          }
	        });
	      }
	    });
	  }
	  n['default'] = e;
	  return Object.freeze(n);
	}

	var React__namespace = /*#__PURE__*/_interopNamespace(React);

	var isBrowser = typeof document !== 'undefined';

	var syncFallback = function syncFallback(create) {
	  return create();
	};

	var useInsertionEffect = React__namespace['useInsertion' + 'Effect'] ? React__namespace['useInsertion' + 'Effect'] : false;
	var useInsertionEffectAlwaysWithSyncFallback = !isBrowser ? syncFallback : useInsertionEffect || syncFallback;
	var useInsertionEffectWithLayoutFallback = useInsertionEffect || React.useLayoutEffect;

	emotionUseInsertionEffectWithFallbacks_cjs_prod.useInsertionEffectAlwaysWithSyncFallback = useInsertionEffectAlwaysWithSyncFallback;
	emotionUseInsertionEffectWithFallbacks_cjs_prod.useInsertionEffectWithLayoutFallback = useInsertionEffectWithLayoutFallback;
	return emotionUseInsertionEffectWithFallbacks_cjs_prod;
}

export { requireEmotionUseInsertionEffectWithFallbacks_cjs_prod as __require };
//# sourceMappingURL=emotion-use-insertion-effect-with-fallbacks.cjs.prod.js.map
